{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:gymnasium-7-informatik-objektorientierung-hypertext-datenstrukturen",
  "version": "2026.08.1",
  "title": "Informatik 7: Objektorientierte Modellierung, Klassendiagramme und Hypertextstrukturen (Gymnasium 7 Bayern)",
  "description": "Geerdetes KVT-Paket für Gymnasium Bayern Informatik 7 (G9): Objektorientierte Strukturierung von Graphik- und Textdokumenten (Objekt, Klasse, Attribut, Methode), UML-Klassendiagramme und Objektdiagramme, Hypertext und Webstrukturen (HTML) sowie Dateisysteme.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T23:25:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/gymnasium/7/informatik",
      "checked": "2026-08-15",
      "label": "Gymnasium Informatik 7, Lernbereiche Objektorientierte Modellierung und Hypertextdokumente"
    }
  ],
  "atoms": [
    {
      "id": "01K4A7C0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4A7C0000000000000000A01",
      "namespace": "gymnasium-informatik-oom",
      "slug": "objektorientierung-objekt-klasse-attribut-methode-uml",
      "title": "Objektorientierte Modellierung: Objekte, Klassen, Attribute, Methoden und UML-Klassendiagramme",
      "domain": "schule/informatik/oom",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q79872",
          "target_label": "Object-oriented programming",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "gymnasium",
          "grade": 7,
          "subject": "informatik",
          "topic_code": "lb1",
          "topic_title": "Objektorientierte Modellierung von Graphiken",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4A7C0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Wie nennt man in der objektorientierten Modellierung den Bauplan / die Schablone, die die gemeinsamen Attribute und Methoden gleichartiger Objekte festlegt?",
          "concept": "Die Klasse (ein Objekt ist eine konkrete Ausprägung / Instanz dieser Klasse)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Die Klasse",
              "Das Attribut"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4A7C0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre die 4 Grundbegriffe der objektorientierten Modellierung (OOM) nach bayerischem Informatik-Lehrplan: 1. **Objekt (Instanz)**: Ein konkreter Gegenstand der realen oder virtuellen Welt mit eindeutigem Bezeichner (*z. B. 'kreis1'*), 2. **Klasse**: Abstrakter Bauplan für gleichartige Objekte (*z. B. 'KREIS'*), 3. **Attribute und Zustand**: Merkmale eines Objekts (*z. B. 'radius', 'fuellfarbe'*); die Gesamtheit aller aktuellen Attributwerte bildet den **Zustand** des Objekts, 4. **Methoden**: Fähigkeiten / Operationen, die den Zustand eines Objekts verändern (*z. B. 'setzeRadius(neuR)', 'verschieben(dx, dy)'*), 5. **UML-Schreibweise**: Dreiteiliger Kasten (Klassenname oben, Attribute in der Mitte, Methoden unten) vs. Objektdiagramm (`kreis1 : KREIS` unterstrichen).",
          "concept": "OOM: Objekt (konkrete Instanz), Klasse (Bauplan), Attribute (Zustand = Wertebelegung), Methoden (Operationen zur Zustandsänderung); UML-Klassendiagramm (3-teilig: Name, Attribute, Methoden) vs. Objektdiagramm (unterstrichen mit konkreten Werten).",
          "sample_solution": "1. Die vier Kernkonzepte der Objektorientierung: - **1. Objekt (Instanz / Exemplar)**:   * Ein individueller, eindeutig identifizierbarer Repräsentant im Programm/Dokument (*z. B. der rote Kreis oben links mit Namen `kreis1`*). - **2. Klasse (Class)**:   * Der allgemeine **Bauplan / Schablone** für alle Objekte einer Art (*z. B. die Klasse `KREIS` oder `RECHTECK`*).   * Definiert, welche Merkmale (Attribute) und Verhaltensweisen (Methoden) jedes Exemplar besitzt. - **3. Attribut und Zustand**:   * **Attribut (Eigenschaft)**: Eine in der Klasse vereinbarte Variable (*z. B. `xPosition`, `yPosition`, `radius`, `fuellFarbe`*).   * **Attributwert**: Die konkrete Belegung des Attributs bei einem einzelnen Objekt (*`radius = 50`, `fuellFarbe = 'rot'`*).   * **Zustand des Objekts**: Die Gesamtheit aller momentanen Attributwerte zu einem bestimmten Zeitpunkt. - **4. Methode (Operation)**:   * Eine an ein Objekt gerichtete Handlungsanweisung oder Botschaft, die dessen Zustand verändert oder Auskunft gibt (*z. B. `faerben('blau')`, `radiusVergroessern(10)`, `nachRechtsVerschieben(25)`*). 2. Standardisierte UML-Diagramme (Unified Modeling Language): - **UML-Klassendiagramm (3 Abschnitte)**:   * 1. Oberes Feld: **Klassenname** (in Großbuchstaben, z. B. `KREIS`).   * 2. Mittleres Feld: **Attribute mit Datentyp** (z. B. `radius : GANZZAHL`, `fuellFarbe : FARBE`).   * 3. Unteres Feld: **Methoden mit Parametern** (z. B. `setzeRadius(r : GANZZAHL)`, `verschieben(dx, dy)`). - **UML-Objektdiagramm**:   * Zeigt ein reales Objekt zu einem bestimmten Zeitpunkt.   * **Kennzeichnung**: Der Kopf ist **zwingend unterstrichen** in der Syntax `objektName : KLASSENNAME` (z. B. `kreis1 : KREIS`).   * Im Rumpf stehen die **aktuellen Attributwerte** (z. B. `radius = 35`, `fuellFarbe = rot`)."
        }
      ]
    },
    {
      "id": "01K4A7C0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4A7C0000000000000000A02",
      "namespace": "gymnasium-informatik-hypertext",
      "slug": "hypertext-html-baumstruktur-dateisystem-pfade",
      "title": "Hypertextstrukturen: HTML (Tags, hierarchischer Baum), relative/absolute Links und Dateipfade",
      "domain": "schule/informatik/hypertext",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4A7C0000000000000000A01",
          "type": "hard",
          "rationale": "HTML-Dokumente sind hierarchische Objektsysteme (DOM-Baum)."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q8811",
          "target_label": "Hypertext",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "gymnasium",
          "grade": 7,
          "subject": "informatik",
          "topic_code": "lb2",
          "topic_title": "Hypertext und Netzstrukturen",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4A7C0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welche Datenstruktur bildet die hierarchische Schachtelung von HTML-Tags in einer Webseite (z. B. `<html>` enthält `<head>` und `<body>`, `<body>` enthält `<p>` und `<h1>`) ab?",
          "concept": "Eine hierarchische Baumstruktur (Tree / DOM-Baum mit Wurzel- und Kindknoten)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Baumstruktur (Baumgraph)",
              "Flache Tabelle"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4A7C0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Analysiere den Aufbau von Hypertext-Dokumenten (HTML) und Dateisystemen: 1. **Hypertext-Prinzip**: Nicht-lineare Textorganisation durch Hyperlinks (Verweise auf andere Dokumente oder Anker im selben Dokument), 2. **HTML-Grundstruktur**: Paarige Tags (`<tag>...</tag>`), Schachtelungsregeln (First In, Last Out: `<b><i>Text</i></b>` ist korrekt; Überkreuzung verboten) und die hierarchische **Baumstruktur (Wurzelknoten `html`, Verzweigungen in `head` und `body`)**, 3. **Relative vs. absolute Pfade**:   * *Absoluter Pfad*: Ausgehend vom Wurzelverzeichnis / vollständige URL (`https://zam.app/images/logo.png` oder `C:/Schule/Informatik/index.html`).   * *Relativer Pfad*: Ausgehend vom aktuellen Verzeichnis (`./bilder/foto.jpg`, `../uebersicht.html` zum Wechsel in den übergeordneten Ordner).",
          "concept": "Hypertext: nicht-linear über Links; HTML: paarige Tags, saubere Schachtelung, Baumstruktur; Pfade: absolut (von Wurzel/URL) vs. relativ (vom aktuellen Ordner über ./ und ../).",
          "sample_solution": "1. Das Wesen von Hypertext: - Während klassische Texte linear (von vorne nach hinten) gelesen werden, ermöglicht **Hypertext** eine vernetzte, nicht-lineare Navigation über interaktive Querverweise (**Hyperlinks**). 2. Die Baumstruktur von HTML (HyperText Markup Language): - **Tags (Auszeichnungselemente)**:   * Werden in spitzen Klammern notiert. Die meisten Tags treten paarweise auf: Start-Tag (z. B. `<p>`) und End-Tag (z. B. `</p>`).   * Tags können Attribute enthalten (z. B. `<a href=\"kontakt.html\">Kontakt</a>` oder `<img src=\"logo.png\" alt=\"Logo\">`). - **Schachtelungsregel (FILO – First In, Last Out)**:   * Ein Tag, der zuletzt geöffnet wurde, muss als Erster wieder geschlossen werden:     - Richtig: `<h1><em>Wichtiger Titel</em></h1>`     - Falsch: `<h1><em>Wichtiger Titel</h1></em>` (Überkreuzungsfehler!). - **Hierarchischer Dokumentbaum (DOM-Baum)**:   * Die Wurzel des Baums ist der `<html>`-Knoten.   * Dieser verzweigt sich in zwei Hauptäste:     - `<head>`: Metadaten, Dokumenttitel (`<title>`), Zeichensatzkodierung.     - `<body>`: Sichtbarer Inhalt für den Benutzer (Absätze `<p>`, Überschriften `<h1>`–`<h6>`, Listen `<ul>`/`<ol>`, Tabellen). 3. Pfadangaben in Dateisystemen und Webanwendungen: - **1. Absolute Pfade**:   * Geben den vollständigen Pfad ausgehend von der obersten Wurzelebene oder als vollständige Web-Adresse an:     - Web: `https://www.gymnasium.bayern.de/faecher/informatik.html`     - Betriebssystem: `/home/schueler/dokumente/referat.pdf`   * *Vorteil*: Eindeutig von jedem beliebigen Ort aus aufrufbar; *Nachteil*: Bricht beim Verschieben des gesamten Projektordners. - **2. Relative Pfade**:   * Beschreiben den Weg zur Zieldatei ausgehend vom **Standort der aktuellen HTML-Datei**:     - `unterordner/bild.jpg`: Datei liegt im Unterverzeichnis.     - `../index.html`: **`..`** springt genau eine Ordnerebene nach oben.     - `../../ressourcen/style.css`: Zwei Ebenen nach oben und dann in den Ordner `ressourcen`."
        }
      ]
    }
  ]
}
